module.exports = __webpack_public_path__ + "img/shi.27bd7feb.png";